<template>
  <div class="row mt-4 mb-4">
    <div class="col-12 col-md-8 text-primary">
      <h5>Muestreo</h5>
    </div>
    <div class="col-12 col-md-8">
      <button
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('word', 'active')"
      >
        Descargar Word
      </button>

      <button
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('excel', 'active')"
      >
        Descargar Excel
      </button>

      <button
        type="button"
        class="btn btn-success btn-with-shadow"
        data-toggle="modal"
        @click="openTab('pdf', 'active')"
      >
        Descargar PDF
      </button>
    </div>
    <div class="col-12 col-md-4">
      <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
        <button
          type="button"
          class="btn btn-primary btn-with-shadow"
          data-toggle="modal"
          @click="openAddEditModal"
        >
          Añadir
        </button>
      </div>
    </div>

    <div class="col-12 mt-4" v-if="accApp">
      <app-table :id="tableId" :options="options" @action="getListAction" />

      <sampling-evaluator-modal
        v-if="isAddEditModalActive"
        :table-id="tableId"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
        :acc-app-id="accApp.id"
        :status-id="status"
      />

      <!-- <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        modal-id="modal-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este registro?"
      /> -->

      <sampling-evaluator-deactivate-modal
        v-if="isDeactivateModalActive"
        modalTitle="Eliminar Muestro"
        :id="rowData.id"
        :table-id="tableId"
        @close-modal="closeDeactivateModal"
        :status-id="status"
      />

      <sampling-evaluator-historical-modal
        v-if="historicalModalActive"
        :id="rowData.id"
        @close-modal="historicalModalClose"
      />
    </div>

    <div v-if="showOriginal">
      <div class="row mt-4 mb-4">
        <legend class="col-12 col-form-label text-primary pt-0 my-3">
          <h5>Muestreo registrado en la solicitud.</h5>
        </legend>
        <div class="col-12 col-md-8">
          <button
            type="button"
            class="btn btn-success btn-with-shadow"
            data-toggle="modal"
            @click="openTab('word', 'original')"
          >
            Descargar Word
          </button>

          <button
            type="button"
            class="btn btn-success btn-with-shadow"
            data-toggle="modal"
            @click="openTab('excel', 'original')"
          >
            Descargar Excel
          </button>

          <button
            type="button"
            class="btn btn-success btn-with-shadow"
            data-toggle="modal"
            @click="openTab('pdf', 'original')"
          >
            Descargar PDF
          </button>
        </div>
      </div>

      <app-table :id="tableId" :options="optionsOriginal" />
    </div>
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  props: {
    disabled: Boolean,
  },
  data() {
    return {
      showOriginal: false,
      historicalModalActive: false,
      deleteLoader: false,
      isAddEditModalActive: false,
      isDeactivateModalActive: false,
      selectedUrl: "",
      rowData: {},
      options: {
        url: "",
        name: "",
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "scope-sampling-modal",
            modalId: "add-edit-modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "sampling-evaluator-deactivate-modal",
            modalId: "delete",
          },
          {
            title: "Histórico",
            icon: "book",
            type: "none",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      optionsOriginal: {
        url: "",
        name: "",
        showHeader: true,
        columns: [],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: false,
        orderBy: "desc",
        actionType: "default",
      },
      tableId: "sampling-table",
      accApp: null,
      evalTest: null,
    };
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": async function(value) {
      if (value) {
        this.accApp = value.accreditation_applications;
        this.evalTest = value;

        this.options.url = `accreditations/sampling/index?accAppId=${this.accApp.id}`;
        this.optionsOriginal.url = `accreditations/sampling/index?accAppId=${this.accApp.id}&original=1&isActive=0`;

        this.data();
      }
    },
  },
  computed: {
    status() {
      let statusId = this.accApp ? this.accApp.status.id : null;
      if (statusId != 43) statusId = this.evalTest.status;
      return statusId;
    },
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.optionsOriginal.columns = [...this.tableColumns];

    if (this.$store.state.accreditation.app.status == 43) {
      this.data();
    }
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `accreditations/sampling/show/${rowData.id}`;
        this.openAddEditModal();
      } else if (actionObj.title == this.$t("Histórico")) {
        this.historicalModalActive = true;
      }
    },

    openDeleteModal() {
      this.isDeactivateModalActive = true;
    },

    closeDeactivateModal() {
      $("#sampling-evaluator-deactivate-modal").modal("hide");
      this.isDeactivateModalActive = false;
      this.reSetData();
    },

    historicalModalClose() {
      this.historicalModalActive = false;
    },

    confirmed() {
      let url = `accreditations/sampling/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.data();
      this.rowData = {};
      this.selectedUrl = "";
    },

    async data() {
      try {
        const result = await this.axiosGet(
          `accreditations/sampling/index?accAppId=${this.accApp.id}&isActive=0`
        );

        const historical = result.data.data;
        const original = historical.filter((row) => row.status_id == null);

        this.showOriginal = historical.length > original.length;
      } catch (error) {
        console.log(error);
      }
    },

    openTab(type, tableName) {
      const url = `/common/sampling/export?
        type=${type}
        &accAppId=${this.accApp.id}
        &statusId=${this.status}
        &tableName=${tableName}`;
        console.log(url);
      window.open(url, "_blank").focus();
    },
  },
};
</script>
